import { Component, EventEmitter, Output, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "drtv-thankyou",
    templateUrl: "./drtv.thankyou.component.html",
    styleUrls: ["./drtv.thankyou.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DrtvThankyouMessageComponent {

  @Output() onPageRefresh: EventEmitter<boolean> = new EventEmitter();

  refreshPage(event) {
    event.preventDefault();
    this.onPageRefresh.emit(true);
  }
}